import { Link } from "react-router-dom";

interface LogoProps {
  variant?: "default" | "inverse";
}

export default function SiteLogo({ variant = "default" }: LogoProps) {
  const textColor = variant === "inverse" ? "text-background-50" : "text-foreground-950";
  return (
    <Link to="/" className="flex items-center gap-2.5 shrink-0 cursor-pointer">
      <span className="w-10 h-10 rounded-lg bg-primary-500 flex items-center justify-center shrink-0">
        <i className="ri-book-open-fill text-background-50 text-xl"></i>
      </span>
      <span className="flex flex-col leading-none">
        <span className={`font-heading font-extrabold text-xl tracking-tight ${textColor}`}>
          老司机漫画
        </span>
        <span className="text-[10px] tracking-[0.2em] text-primary-600 font-label mt-0.5">
          LAO SIJI COMIC
        </span>
      </span>
    </Link>
  );
}